export const onIdle = (callback: () => void) => {
  /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
   */
  const requestIdleCallback = window.requestIdleCallback;

  if (requestIdleCallback) {
    requestIdleCallback(callback);
  } else {
    // eslint-disable-next-line n/callback-return
    callback();
  }
};
